<template>
  <v-card class="payments matter-engagement-tab entity-list">
    <div class="top-header" :class="{'small-screen': isSmallScreen && !isSummaryLoading}">
      <SkeletonText :loading="isSummaryLoading" >
        <PaymentMeters :meters="metersData" :small-screen="isSmallScreen" />
      </SkeletonText>
    </div>
    <div class="payments-panels-wrapper" ref="paymentsSctions">
      <ExpansionPanels
        :multiple="false"
        :disable-hover="false"
        :on-hover-color="hoverColor"
        @panel-change="panelChanged"
        :items="paymentSections"
        :direction="direction">
        <template slot="content"
                  slot-scope="{item}">
          <div class="payments-panel"
               v-if="item.id === 'overdueAndDuePayments' && activePanel === 0">
            <PaymentList
              list-name="overdueAndDuePayments"
              page="overdueAndDuePaymentsPage"
              set-page="setOverdueAndDuePaymentsPage"
              getter-completed="overdueAndDuePaymentsCompleted"
              :refreshId="refreshId"
              navigateTo=""
              load-data="loadOverdueAndDuePayments" >
              <template v-slot:item-prview="{ item }">
                <FrontageLink
                  v-if="item.payable_type === 'Invoice'"
                  to="app.invoice.show"
                  :params="{uid: item.payable_uid, origin: 'Client card payments tab'}" >
                  <MatterPaymentRow
                    :payment="item"
                    :showStaff="isMultipleStaffs" />
                </FrontageLink>

                <FrontageLink
                  v-if="item.payable_type === 'Meeting'"
                  to="app.appointment.show"
                  :params="{uid: item.payable_uid}" >
                  <MatterPaymentRow
                    :payment="item"
                    :showStaff="isMultipleStaffs" />
                </FrontageLink>

                <FrontageLink
                  v-if="item.payable_type === 'EventAttendance'"
                  to="app.payment_status.show"
                  :params="{uid: item.uid}" >
                  <MatterPaymentRow
                    :payment="item"
                    :showStaff="isMultipleStaffs" />
                </FrontageLink>

                <FrontageLink
                  v-if="item.payable_type === 'ClientBookingPackage'"
                  to="app.client-package.show"
                  :params="{uid: item.payable_uid, origin: 'Client card payments tab'}" >
                  <MatterPaymentRow
                    :payment="item"
                    :showStaff="isMultipleStaffs" />
                </FrontageLink>

                <FrontageLink
                  v-if="item.payable_type === 'ProductOrder'"
                  to="app.product-order.show"
                  :params="{uid: item.payable_uid}" >
                  <MatterPaymentRow
                    :payment="item"
                    :showStaff="isMultipleStaffs" />
                </FrontageLink>
              </template>
            </PaymentList>
          </div>

          <div class="payments-panel"
               v-if="item.id === 'notYetDuePayments' && activePanel === 1">
            <PaymentList
              list-name="notYetDuePayments"
              page="notYetDuePaymentsPage"
              set-page="setNotYetDuePaymentsPage"
              getter-completed="notYetDuePaymentsCompleted"
              :refreshId="refreshId"
              navigateTo=""
              load-data="loadNotYetDuePayments" >
              <template v-slot:item-prview="{ item }">
                <FrontageLink
                  v-if="item.payable_type === 'Invoice'"
                  to="app.invoice.show"
                  :params="{uid: item.payable_uid, origin: 'Client card payments tab'}" >
                  <MatterPaymentRow
                    :payment="item"
                    :showStaff="isMultipleStaffs" />
                </FrontageLink>

                <FrontageLink
                  v-if="item.payable_type === 'Meeting'"
                  to="app.appointment.show"
                  :params="{uid: item.payable_uid}" >
                  <MatterPaymentRow
                    :payment="item"
                    :showStaff="isMultipleStaffs" />
                </FrontageLink>

                <FrontageLink
                  v-if="item.payable_type === 'EventAttendance'"
                  to="app.payment_status.show"
                  :params="{uid: item.uid}" >
                  <MatterPaymentRow
                    :payment="item"
                    :showStaff="isMultipleStaffs" />
                </FrontageLink>

                <FrontageLink
                  v-if="item.payable_type === 'ClientBookingPackage'"
                  to="app.client-package.show"
                  :params="{uid: item.payable_uid, origin: 'Client card payments tab'}" >
                  <MatterPaymentRow
                    :payment="item"
                    :showStaff="isMultipleStaffs" />
                </FrontageLink>

                <FrontageLink
                  v-if="item.payable_type === 'ProductOrder'"
                  to="app.product-order.show"
                  :params="{uid: item.payable_uid}" >
                  <MatterPaymentRow
                    :payment="item"
                    :showStaff="isMultipleStaffs" />
                </FrontageLink>
              </template>
            </PaymentList>
          </div>

          <div class="payments-panel"
               v-if="item.id === 'paymentsReceived' && activePanel === 2">
            <PaymentList
              list-name="receivedPayments"
              page="receivedPaymentsPage"
              set-page="setReceivedPaymentsPage"
              getter-completed="receivedPaymentsCompleted"
              :refreshId="refreshId"
              navigateTo="app.payment.show"
              load-data="loadReceivedPayments" />
          </div>
          <div class="payments-panel last-panel"
               v-if="item.id === 'estimates' && activePanel === 3">
            <PaymentList
              list-name="estimatesPayments"
              page="estimatesPaymentsPage"
              set-page="setEstimatesPaymentsPage"
              getter-completed="estimatesPaymentsCompleted"
              :refreshId="refreshId"
              navigateTo="app.estimate.show"
              load-data="loadEstimatesPayments" />
          </div>
        </template>
      </ExpansionPanels>
    </div>

    <div v-if="isTakePaymentEligible" @click="takePayment" class="d-flex flex-row align-center justify-center take-payment-button" :class="{'disabled': isTakePaymentEnabled === false, 'rtl': $vuetify.rtl}">
      <span>{{$t('conversation.action.take_payment')}}</span>
    </div>

    <FabBtn
      v-if="isMobile"
      :bgColor="brandBgColor"
      :textColor="brandTxtColor"
      custom-class="bottom-right"
      @click="handleMobileBtnClicks()"
      icon="icon-payments-plus" />

    <v-tooltip v-else
               top
               content-class="fab-tooltip">
      <template v-slot:activator="{ on, attrs }">
        <span class="fab-btn bottom-right add-payment-btn-desktop"
              v-bind="attrs"
              v-on="on">
          <DropdownMenu
            :top="true"
            :left="!isRightToLeft"
            :right="isRightToLeft"
            :offsetY="true"
            :items="paymentsActions"
            @item-clicked="actionsClicked">
            <v-btn :color="brandBgColor" rounded fab>
              <v-icon :color="brandTxtColor">icon-payments-plus</v-icon>
            </v-btn>
          </DropdownMenu>
        </span>
      </template>
      <span>
      {{$t('client.matters.matter_page.fabs.payments')}}
      </span>
    </v-tooltip>

  </v-card>
</template>

<script>
import {
  ExpansionPanels,
  FabBtn,
  SkeletonText,
  DropdownMenu,
  FrontageLink,
} from "@/modules/common/components"
import {PaymentMeters} from "@/modules/payments/components"
import PaymentList from "@/modules/matters/components/PaymentList/PaymentList"
import MatterPaymentRow from "@/modules/matters/components/MatterPaymentRow/MatterPaymentRow"
import {setHeight} from "@/modules/matters/directives"
import {mapGetters} from "vuex";
import matterActionsService from "@/modules/matters/services/matterActionsService";

export default {
  name: "Payments",
  components: {
    PaymentMeters,
    ExpansionPanels,
    FabBtn,
    SkeletonText,
    FrontageLink,
    DropdownMenu,
    PaymentList,
    MatterPaymentRow,
  },
  directives: {
    'set-height': setHeight
  },
  props: {
    isSmallScreen: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: true,
      isOpen: false,
      activePanel: false,
      refreshId: 0,
      paymentSections: [
        {id: 'overdueAndDuePayments', name: this.$t('client.matters.matter_page.payments_tab.overdue_and_due_title'), trackingLabel: 'overdue and due payments' },
        {id: 'notYetDuePayments', name: this.$t('client.matters.matter_page.payments_tab.not_yet_due_title'), trackingLabel: 'not yet due payments' },
        {id: 'paymentsReceived', name: this.$t('client.matters.matter_page.payments_tab.received_title'), trackingLabel: 'payments received'},
        {id: 'estimates', name: this.$t('client.matters.matter_page.payments_tab.estimates_title'), trackingLabel: 'estimates'}
      ],
      sectionMaxHeight: 0,
    }
  },
  created(){
    this.$frontageApi.listen('fetch-payments', this.onRefreshEvent)
    this.refresh()
  },
  computed: {
    ...mapGetters(['isRightToLeft', 'direction']),
    ...mapGetters("brandModule", ["hoverColor"]),
    ...mapGetters("accountModule", ["business"]),
    summary() {
      return this.$store.getters['mattersModule/paymentsSummary']
    },
    isSummaryLoading() {
      return this.$store.getters['mattersModule/paymentsSummaryLoading']
    },
    isTakePaymentEligible(){
      return !this.isSmallScreen &&
             this.business.ab_test?.manual_close_balance_buttons === 'two';
    },
    isTakePaymentEnabled(){
      return this.summary && Boolean(parseInt(this.summary.open.value));
    },
    isMultipleStaffs() {
      return this.$store.getters['accountModule/isMultipleStaffs']
    },
    currContact() {
      return this.$store.getters['mattersModule/currContact']
    },
    currMatter() {
      return this.$store.getters['mattersModule/matter']
    },
    brandBgColor() {
      return this.$store.getters['brandModule/secondaryColor']
    },
    brandTxtColor() {
      return this.$store.getters['brandModule/textColor']
    },
    metersData(){
      if (!this.summary) return
      return Object.keys(this.summary).reduce((acc, item) => {
        acc[item] = this.summary[item].value_h
        return acc
      }, {});
    },
    paymentsActions() {
      return matterActionsService.getActions('invoice', 'estimate', 'packages', 'products', 'accept_payment', 'record_payment')
    }
  },
  methods: {
    handleMobileBtnClicks() {
      this.$frontageApi.send('matter_action', {action: 'add_payment'});
    },
    actionsClicked(e) {
      this.$frontageApi.send('matter_action', {action: 'all_actions', action_name: e.action, origin: 'Payments tab fab'});
    },
    panelChanged(index) {
      this.isOpen = index !== undefined && index > -1
      this.activePanel = index
      index > -1 && this.$track(`Client card ${this.paymentSections[index].trackingLabel} panel`)
    },
    onRefreshEvent({clientUid}) {
      if (this.currContact.uid !== clientUid) return
      this.refresh()
    },
    refresh() {
      this.$store.dispatch({type: "mattersModule/resetPayments"})
      this.$store.dispatch({type: 'mattersModule/loadPaymentsSummary'})
      this.refreshId++
    },
    takePayment(){
      if (!this.isTakePaymentEnabled) return;
      this.handlePaymentsAnalytics();
      this.$frontageApi.send('open_close_balance_dialog', {client_uid: this.currContact.uid, matter_uid: this.currMatter.uid})
    },
    handlePaymentsAnalytics(){
      const abTest = ({
        "one": "only top",
        "two": "multiple buttons"
      })[this.business.ab_test?.manual_close_balance_buttons]
      this.$track('Close Balance Take Payment – Click', {Origin: 'payment tab button', "ab test multi buttons": abTest})
    }
  },
  destroyed() {
    this.$frontageApi.remove('fetch-payments', this.onRefreshEvent)
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/abstract/_variables.scss";
@import '@/assets/scss/abstract/_i18n-mixins';

.payments.matter-engagement-tab {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  .take-payment-button{
    height: 30px;
    width: 128px;
    position: absolute;
    right: 24px;
    top: 108px;
    background-color: #ededf2;
    cursor: pointer;
    font-size: 12px;
    font-family: var(--primary-font-family);
    font-weight: 500;
    border-radius: 3px;
    &.disabled{
      color: rgba(0, 0, 0, 0.3);
      cursor: default;
    }
    &.rtl{
      right: 75%;
    }
  }

  .top-header {
    padding: 15px 10px 18px 10px;
    border-bottom: 1px solid $grey-color-2;

    &.small-screen {
      padding: 0;
    }
  }

  .payments-panels-wrapper {
    flex: 1;
  }

  .payments-panel {
    display: flex;

    &.last-panel .payment-list {
      padding-bottom: 20px;
    }
  }

  .add-payment-btn-desktop {
    position: absolute;

    .v-btn {
      height: 50px;
      width: 50px;
    }
  }
}

.fab-tooltip {
  font-family: var(--primary-font-family);
  font-size: 12px;
  line-height: 18px;
  z-index: 50 !important;
}
</style>
